import { render } from "./JobenterpriseAllocation.vue?vue&type=template&id=b23216e8&scoped=true"
import script from "./JobenterpriseAllocation.vue?vue&type=script&lang=js"
export * from "./JobenterpriseAllocation.vue?vue&type=script&lang=js"

import "./JobenterpriseAllocation.vue?vue&type=style&index=0&id=b23216e8&scoped=true&lang=css"
import "./JobenterpriseAllocation.vue?vue&type=style&index=1&id=b23216e8&lang=css"
script.render = render
script.__scopeId = "data-v-b23216e8"

export default script